import { createContext, useContext } from 'react'

export type ToastTone = 'success' | 'error' | 'info'

export type ToastRequest = {
  title: string
  description?: string
  tone?: ToastTone
}

export type ToastMessage = ToastRequest & { id: string }

export type ToastApi = { notify: (request: ToastRequest) => void }

export const ToastContext = createContext<ToastApi | null>(null)

export const useToast = (): ToastApi => {
  const api = useContext(ToastContext)

  if (api === null) {
    throw new Error('useToast must be used inside <ToastProvider>')
  }

  return api
}
